<script>
	import QuantitySelect from './QuantitySelect.svelte'
	import Subtotal from './Subtotal.svelte'
	import SubtleButton from './SubtleButton.svelte'

	export let api, group

	$: all_item_quantities_are_the_same = group.items.every(item => item.quantity === group.items[0].quantity)
</script>

<div class="controls">
	{#if all_item_quantities_are_the_same}
		<QuantitySelect
			max="{Math.min(...group.items.map(({ item }) => item.max_quantity))}"
			bind:value="{group.quantity}"
			on:change="{() => api(`/lineitem_group/update`, { lineitem_group_id: group.group_id, quantity: group.quantity })}"
		/>
	{/if}

	<SubtleButton on:click="{() => api(`/lineitem_group/remove`, { lineitem_group_id: group.group_id })}">Remove</SubtleButton>

	<Subtotal subtotal="{group.items.reduce((acc, { item }) => acc + item.line_subtotal, 0)}" />
</div>

<style>
	.controls {
		display: flex;
		flex-shrink: 0;
		flex-direction: row;
		align-items: center;
		justify-content: flex-end;
		margin: 10px;
		gap: 20px;
	}

	@media (max-width: 600px) {
		.controls {
			gap: 10px;
			margin: 0;
		}
	}
</style>
